<template>
  <div>
    <Login />
  </div>
</template>

<script>
  import Login from "./auth/Login";

  export default {
    name: "Home",
    components: {
      Login,
    }
  };
</script>
